import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import modernAduImage from "@/assets/modern-adu-design-bay-area.png";
import zoningImage from "@/assets/what-can-you-build-adu-zoning.png";
import farmhouseImage from "@/assets/modern-farmhouse-adu-popular.png";
import designBuildImage from "@/assets/adu-design-build-process.png";
import smallAduImage from "@/assets/small-adu-feel-bigger.png";
import backyardImage from "@/assets/backyard-usable-living-space.png";
import rentalIncomeImage from "@/assets/adu-rental-income-california.png";
import fasterPermitsImage from "@/assets/simple-adus-faster-permits.png";
import flatRoofImage from "@/assets/modern-adu-flat-roof-design.png";
import fullServiceImage from "@/assets/full-service-adu-solutions.png";
import optimizingSmallImage from "@/assets/optimizing-small-adu-spaces.png";
import customMatchImage from "@/assets/custom-adus-match-your-home.png";
import privacyComfortImage from "@/assets/adu-privacy-comfort-design.png";
import indoorOutdoorImage from "@/assets/indoor-outdoor-adu-living.png";
import indoorOutdoorValueImage from "@/assets/indoor-outdoor-adu-value.png";
import propertyValueImage from "@/assets/investing-in-adus-property-value.png";

const blogPosts = [
  {
    slug: "modern-adu-design-bay-area",
    title: "Modern ADU Design in the Bay Area",
    excerpt: "When most people think about building an ADU in the Bay Area, they start with design. Clean lines, modern finishes, something that feels like a natural extension of the home. But design is only one piece of it.",
    image: modernAduImage,
    date: "April 1, 2026",
  },
  {
    slug: "adu-zoning-explained",
    title: "What Can You Build on Your Property? ADU Zoning Explained",
    excerpt: "One of the first questions we get is simple. What can I build on my property? The answer depends on more than just lot size. Zoning, setbacks, easements, and existing structures all play a role.",
    image: zoningImage,
    date: "April 2, 2026",
  },
  {
    slug: "modern-farmhouse-adus-popular",
    title: "Why Modern Farmhouse ADUs Are So Popular",
    excerpt: "Modern farmhouse ADUs have become one of the most requested styles in California, and for good reason. They feel familiar. Clean white siding, black accents, simple rooflines.",
    image: farmhouseImage,
    date: "April 3, 2026",
  },
  {
    slug: "adu-design-build-process",
    title: "The ADU Design Build Process Made Simple",
    excerpt: "A lot of homeowners hesitate to start because the process feels overwhelming. Design, permits, construction. Different people, different timelines, too many unknowns.",
    image: designBuildImage,
    date: "April 4, 2026",
  },
  {
    slug: "small-adu-feel-bigger",
    title: "How to Make a Small ADU Feel Bigger",
    excerpt: "One of the biggest concerns homeowners have is space. The answer is not just square footage. It's how the space is designed.",
    image: smallAduImage,
    date: "April 5, 2026",
  },
  {
    slug: "backyard-usable-living-space",
    title: "Turning Your Backyard Into Usable Living Space",
    excerpt: "Most backyards are underused. An ADU changes that completely. Instead of just placing a unit in the yard, we look at the entire space.",
    image: backyardImage,
    date: "April 6, 2026",
  },
  {
    slug: "adu-rental-income-california",
    title: "How ADUs Create Rental Income in California",
    excerpt: "More homeowners are building ADUs for one reason. Income. In many parts of California, an ADU can generate consistent rental income and increase overall property value.",
    image: rentalIncomeImage,
    date: "April 7, 2026",
  },
  {
    slug: "simple-adus-faster-permits",
    title: "Simple ADUs That Move Faster Through Permits",
    excerpt: "Not every project needs to be complex. In many cases, simpler ADUs move faster through city approvals and are easier to build.",
    image: fasterPermitsImage,
    date: "April 8, 2026",
  },
  {
    slug: "modern-adu-flat-roof-design",
    title: "Modern ADUs With Flat Roof Design",
    excerpt: "Flat roof ADUs have become more common, especially for homeowners looking for a modern look. They allow for clean lines, large windows, and open interiors.",
    image: flatRoofImage,
    date: "April 9, 2026",
  },
  {
    slug: "full-service-adu-solutions",
    title: "Full Service ADU Solutions in California",
    excerpt: "Most homeowners don't realize this at the beginning. Building an ADU is not just about construction. It's a process that involves design decisions, city approvals, engineering, and coordination across multiple moving parts.",
    image: fullServiceImage,
    date: "April 10, 2026",
  },
  {
    slug: "optimizing-small-adu-spaces",
    title: "Optimizing Small ADU Spaces",
    excerpt: "Most people think small means limited. A well-designed ADU does not feel small. It feels efficient. Every inch has a purpose.",
    image: optimizingSmallImage,
    date: "April 11, 2026",
  },
  {
    slug: "custom-adus-match-your-home",
    title: "Custom ADUs That Match Your Home",
    excerpt: "Most homeowners don't want an ADU that feels separate. They want something that belongs. When the ADU matches the main house, the entire property feels complete.",
    image: customMatchImage,
    date: "April 12, 2026",
  },
  {
    slug: "investing-in-adus-property-value",
    title: "Why Investing in ADUs Amplifies Property Value",
    excerpt: "A well-designed ADU adds equity, creates rental income, and strengthens long-term property appeal. That is what makes it such a strong investment.",
    image: propertyValueImage,
    date: "April 13, 2026",
  },
  {
    slug: "adu-privacy-comfort-design",
    title: "Backyard ADUs Designed for Privacy and Comfort",
    excerpt: "The biggest issue is not size. It's privacy. When an ADU feels too close or too exposed, it stops feeling like a real home.",
    image: indoorOutdoorValueImage,
    date: "April 14, 2026",
  },
  {
    slug: "indoor-outdoor-adu-living",
    title: "Indoor Outdoor ADU Living: Spaces That Feel Open and Connected",
    excerpt: "Indoor outdoor living is not about adding a patio. It starts with how the entire space is planned. When done right, the ADU feels larger, brighter, and more comfortable.",
    image: indoorOutdoorImage,
    date: "April 15, 2026",
  },
];

const Blogs = () => {
  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs" />
      <Navigation />

      <main className="max-w-6xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-foreground">
            UDA ADU Blog
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Insights, tips, and expert advice on building ADUs in the Bay Area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blogs/${post.slug}`}
              className="group rounded-2xl overflow-hidden border border-border bg-card hover:shadow-lg transition-all duration-300"
            >
              <div className="w-full overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-auto group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <p className="text-sm text-muted-foreground mb-2">{post.date}</p>
                <h2 className="text-xl font-semibold text-foreground mb-3 group-hover:text-primary transition-colors">
                  {post.title}
                </h2>
                <p className="text-muted-foreground text-sm line-clamp-3">
                  {post.excerpt}
                </p>
                <span className="inline-block mt-4 text-primary font-medium text-sm group-hover:underline">
                  Read More →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </main>

      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default Blogs;
